export default __webpack_public_path__ + "static/media/p-value.642554b6.jpg";